import React, { Component } from 'react'
import Card from '@material-ui/core/Card'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TablePagination from '@material-ui/core/TablePagination'
import ExpandMore from '@material-ui/icons/ExpandMore'
import ChevronRight from '@material-ui/icons/ChevronRight'

import surveyApiService from '../../providers/survey/surveyApiService'
import { userName, formatDate, Stars } from './surveyHelpers'

import './SurveyRatingsStyles.css'

const roleLabel = (survey) => survey.role === 'seller' ? 'Seller → Buyer' : 'Buyer → Assessor'

/**
 * A section of the Survey Ratings page holding every survey of one status on a
 * single list, newest first - `awaiting` for the ones a user still has to fill
 * in, `completed` for the submitted ones. It is closed until opened, and loads
 * its list the first time it is. Opening a completed row shows its per-question
 * breakdown.
 */
class SurveyStatusList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false,
      surveys: [],
      totalCount: 0,
      page: 0,
      limit: 25,
      loaded: false,
      expanded: {}
    }
    this.toggleOpen = this.toggleOpen.bind(this)
    this.handleChangePage = this.handleChangePage.bind(this)
    this.handleChangeLimit = this.handleChangeLimit.bind(this)
  }

  toggleOpen () {
    const open = !this.state.open
    this.setState({ open }, () => {
      if (open && !this.state.loaded) this.load()
    })
  }

  isCompleted () {
    return this.props.status === 'completed'
  }

  async load () {
    const { page, limit } = this.state
    const res = await surveyApiService.getSurveys({ page: page + 1, limit, status: this.props.status })
    this.setState({
      surveys: res.surveys,
      totalCount: res.totalCount,
      loaded: true
    })
  }

  handleChangePage (event, page) {
    this.setState({ page }, () => this.load())
  }

  handleChangeLimit (event) {
    this.setState({ limit: parseInt(event.target.value, 10), page: 0 }, () => this.load())
  }

  toggleExpand (id) {
    if (!this.isCompleted()) return
    this.setState(prev => ({
      expanded: { ...prev.expanded, [id]: !prev.expanded[id] }
    }))
  }

  renderAnswers (survey) {
    if (!this.state.expanded[survey._id]) return null
    return (
      <TableRow key={`${survey._id}-answers`} className='answers-row'>
        <TableCell colSpan={7}>
          <div className='answers-wrap'>
            {(survey.answers || []).map((answer, index) => (
              <div className='answer-line' key={index}>
                <span className='answer-title'>
                  {answer.title}
                  {Number(answer.weight) > 0 &&
                    <span className='answer-weight'>{answer.weight}%</span>}
                </span>
                <Stars value={answer.rating} />
              </div>
            ))}
          </div>
        </TableCell>
      </TableRow>
    )
  }

  renderSurvey (survey) {
    const completed = this.isCompleted()
    const lot = survey.lot || {}
    const lotTitle = (lot.publicDetails && lot.publicDetails.title) || '-'
    return [
      <TableRow
        key={survey._id}
        className={completed ? 'rating-row flat' : 'pending-row'}
        onClick={() => this.toggleExpand(survey._id)}
      >
        <TableCell className='lot-id'>{lot.searchNumericId || '-'}</TableCell>
        <TableCell>{lotTitle}</TableCell>
        {completed && <TableCell><Stars value={survey.rating} /></TableCell>}
        <TableCell>{userName(survey.respondent)}</TableCell>
        <TableCell>{userName(survey.subject)}</TableCell>
        <TableCell className='role-cell'>{roleLabel(survey)}</TableCell>
        <TableCell>{formatDate(completed ? (survey.completedAt || survey.createdAt) : survey.createdAt)}</TableCell>
      </TableRow>,
      completed && this.renderAnswers(survey)
    ]
  }

  render () {
    const { open, surveys, totalCount, page, limit, loaded } = this.state
    const completed = this.isCompleted()
    const columns = completed ? 7 : 6

    return (
      <Card className='survey-ratings-list survey-status-section'>
        <div className='survey-status-header' onClick={this.toggleOpen}>
          {open ? <ExpandMore className='auction-chevron' /> : <ChevronRight className='auction-chevron' />}
          <span className='survey-status-title'>{completed ? 'Completed Surveys' : 'Pending Surveys'}</span>
          {loaded && <span className='survey-status-count'>{totalCount}</span>}
        </div>
        {open && <div>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Lot ID</TableCell>
                <TableCell>Lot Name</TableCell>
                {completed && <TableCell>Rating</TableCell>}
                <TableCell>{completed ? 'From User' : 'Waiting On'}</TableCell>
                <TableCell>Rated User</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>{completed ? 'Completed' : 'Sent'}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loaded && surveys.length === 0 &&
                <TableRow>
                  <TableCell colSpan={columns}>
                    {completed ? 'No surveys completed yet.' : 'No surveys are pending.'}
                  </TableCell>
                </TableRow>}

              {surveys.map(survey => this.renderSurvey(survey))}
            </TableBody>
          </Table>

          <TablePagination
            component='div'
            count={totalCount}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[10, 25, 50, 100]}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeLimit}
          />
        </div>}
      </Card>
    )
  }
}

export default SurveyStatusList
